import React from 'react'
import { Link } from '../../core'
import { Modal, ModalCard, ModalCardBody } from '../../bulma'

class SubscriptionInfoModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
    }
  }

  render() {
    const {
      content, title, checkoutStep, modal, ...rest
    } = this.props

    return (
      <span>
        <Link href="#" eventCategory="Checkout" eventAction={`${modal} Info`} eventLabel={`${checkoutStep} | Open Modal`} trackEvent onClick={() => this.setState({ showModal: true })}>Learn More</Link>
        <Modal
          isActive={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
        >
          <ModalCard
            cardTitle={title}
            onClose={() => this.setState({ showModal: false })}
          >
            <ModalCardBody>
              {content}
            </ModalCardBody>
          </ModalCard>
        </Modal>
      </span>
    )
  }
}

export default SubscriptionInfoModal
